import type { DataSourceDeclaration } from '@de/providers/DataSourceManager.types';
import {
  createDataSourceTypeRegistry,
  type DataSourceTypeDescriptor,
  type DataSourceTypeRegistry,
} from '../source-type-registry';
import { httpSourceType } from './httpSourceType';
import { inferenceSourceType } from './inferenceSourceType';
import { reportingModelSourceType } from './reportingModelSourceType';

export {
  createDataSourceTypeRegistry,
  type DataSourceHostConfig,
  type DataSourceTypeDescriptor,
  type DataSourceTypeRegistry,
} from '../source-type-registry';
export { httpSourceType } from './httpSourceType';
export { inferenceSourceType } from './inferenceSourceType';
export { reportingModelSourceType } from './reportingModelSourceType';

/**
 * The source types the runtime ships with.
 *
 * Registration runs at module load, so an incomplete descriptor fails when
 * this module is first imported rather than at whatever request happens to
 * need the missing member.
 */
export const dataSourceTypes: DataSourceTypeRegistry =
  createDataSourceTypeRegistry();

dataSourceTypes.register(httpSourceType);
dataSourceTypes.register(reportingModelSourceType);
dataSourceTypes.register(inferenceSourceType);

/**
 * The descriptor for `decl`, or `null` when its `kind` is not registered.
 *
 * An unregistered kind is a document written against a newer runtime than the
 * one rendering it. Callers report it rather than guessing a type, because
 * guessing would send a request shaped by rules the author did not choose.
 */
export function resolveDataSourceType(
  decl: DataSourceDeclaration,
): DataSourceTypeDescriptor | null {
  return dataSourceTypes.resolve(decl);
}
